import {
  AdjustmentCertificateIcon,
  DataloggingIcon,
  PlayIcon,
  StopIcon,
  AcqChainIcon,
  AmbulanceIcon,
  BellSlashIcon,
  CogsIcon,
  FileSignatureIcon,
  BatteryQuarterIcon,
  PlugIcon,
  BoxOpenIcon,
} from 'src/components/common/icons'

export const channelStatus = {
  REAL_TIME: {
    i18n: 'WEB_ACQ_CHAIN_REAL_TIME',
    icon: PlayIcon,
    color: 'success',
    group: 'ACQUISITION_CHAIN_STATUS',
  },
  DATALOGGING: {
    i18n: 'WEB_ACQ_CHAIN_DATALOGGING',
    icon: DataloggingIcon,
    color: 'info',
    group: 'ACQUISITION_CHAIN_STATUS',
  },
  STOPPED: {
    i18n: 'WEB_ACQ_CHAIN_STOPPED',
    icon: StopIcon,
    color: 'warning',
    group: 'ACQUISITION_CHAIN_STATUS',
  },
  ACQ_CHAIN_NOT_AFFECTED: {
    i18n: 'WEB_ACQ_CHAIN_NOT_AFFECTED',
    icon: AcqChainIcon,
    color: 'danger',
    group: 'ACQUISITION_CHAIN_STATUS',
  },
  NO_ADJUSTMENT_CERTIFICATE: {
    i18n: 'WEB_NO_ADJUSTMENT_CERTIFICATE',
    icon: AdjustmentCertificateIcon,
    color: 'danger',
  },
  MISSION: {
    i18n: 'WEB_ACQ_CHAIN_MISSION',
    icon: AmbulanceIcon,
    color: 'info',
  },
  ALERTS_DISABLED: {
    i18n: 'WEB_ALERTS_DISABLED',
    icon: BellSlashIcon,
    color: 'danger',
  },
  LOW_BATTERY: {
    i18n: 'WEB_ACQ_CHAIN_LOW_BATTERY',
    icon: BatteryQuarterIcon,
    color: 'warning',
  },
  POWER_SUPPLY: {
    i18n: 'WEB_ACQ_CHAIN_POWER_SUPPLY',
    icon: PlugIcon,
    color: 'danger',
  },
  DEVICE_IN_STOCK: {
    i18n: 'WEB_DEVICE_IN_STOCK',
    icon: BoxOpenIcon,
    color: 'info',
  },
  PENDING_ACTIONS: {
    i18n: 'WEB_ACQ_CHAIN_PENDING_ACTIONS',
    icon: CogsIcon,
    color: 'info',
  },
  CALIBRATION_NEARLY_OVER: {
    i18n: 'WEB_CALIBRATION_NEARLY_OVER',
    icon: FileSignatureIcon,
    color: 'warning',
    group: 'CALIBRATION_CERTIFICATE_STATUS',
  },
  CALIBRATION_OVER: {
    i18n: 'WEB_CALIBRATION_OVER',
    icon: FileSignatureIcon,
    color: 'danger',
    group: 'CALIBRATION_CERTIFICATE_STATUS',
  },
}

export const uncertaintyMethods = {
  OFF: {
    i18n: 'WEB_OFF_UNCERTAINTY',
  },
  STANDARD: {
    i18n: 'WEB_STANDARD_UNCERTAINTY',
    formula: '|u| =',
  },
  GLOBAL: {
    i18n: 'WEB_GLOBAL_UNCERTAINTY',
    formula: '|u| + |σ| =',
  },
  CUSTOM: {
    i18n: 'WEB_CUSTOM_UNCERTAINTY',
  },
  CORRECTED: {
    i18n: 'WEB_CORRECTED_WITH_ERROR_UNCERTAINTY',
    formula: '|u| + σ =',
  },
}
